export const environment = {
  production: false,
  envName: "dev",
  /**
   * Cloud Run task-api in africa-south1.
   *
   * There is no Firestore fallback, so Checklists and Assignments fail whenever
   * this is unreachable — including any time the dev Cloud SQL instance is
   * stopped, which it is between working sessions to keep the bill at ~$2/mo.
   * Start it from the Dev Database screen (`/admin/database`, SuperAdmin only)
   * before using those pages — that also arms the two-hour auto-stop, which
   * `gcloud sql instances patch --activation-policy=ALWAYS` does not.
   */
  taskApiUrl: "https://task-api-29692807164.africa-south1.run.app",
  firebase: {
    apiKey: "AIzaSyDck28AFSD7B9K7LFLPirclIqMP-_FhdK8",
    authDomain: "dev.taolo.co.za",
    projectId: "taolo-dev",
    storageBucket: "taolo-dev.firebasestorage.app",
    messagingSenderId: "29692807164",
    appId: "1:29692807164:web:60bdab8766df5f550c5479",
  },
};
